<template>
  <ElDialog
    v-loading="loading"
    @before-close="onBeforeCloseModal"
    :title="$t('companySettings.billing.invoicePreview.purchaseCreditsTitle')"
    v-on="$listeners"
    :visible="show"
    append-to-body>
    <div>
      <VForm :onSubmit="openInvoicePreview" data-vv-scope="order" ref="form">
        <div slot="row">
          <VMessage
            v-if="paymentMethodPending"
            type="warning"
            subtype="outlined"
            :fullwidth="true">
            <template v-slot:icon>
              <InfoCircleIcon />
            </template>
            <template v-slot:text>
              {{ $t('companySettings.billing.confirmPlan.ddPendingMessage') }}
            </template>
          </VMessage>
        </div>
        <div slot="row">
          {{ $t('companySettings.billing.invoicePreview.infoMessage') }}
        </div>
        <div slot="row" v-if="!paymentMethods.length">
          <VMessage
            type="warning"
            :fullwidth="true">
            <template v-slot:icon>
              <ExclamationTriangleIcon />
            </template>
            <template v-slot:text>
              {{ $t('companySettings.billing.confirmPlan.noValidMethodsMessage') }}
            </template>
          </VMessage>
        </div>
        <div slot="row">
          <VGrid class="purchase-credits-modal__grid" v-if="paygPlans">
            <div
                v-for="(item, index) in paygPlans"
                :key="index"
                slot="gridItem"
                type="6"
            >
              <VCheckbox
                type="radio"
                name="reminder-interval"
                :checked="index === 0"
                v-model="quantity"
                :radio-value="item.quantity.toString()"
                data-ec="billing_add_credits_modal"
                :data-et="`option_${item.quantity}`" />
              <b class="check-label">
                &ensp; {{ $t('companySettings.billing.invoicePreview.creditsForPrice', { quantity: item.quantity, price: $n(parseFloat(item.amount / 100), 'currency', item.currency) }) }}
              </b><br />
            </div>
          </VGrid>
        </div>
        <div slot="row">
          {{ $t('companySettings.billing.invoicePreview.vatExcluded') }}
        </div>
        <div slot="formButtons">
          <VButton
              v-if="!paymentMethods.length"
              class="add-credits-modal__button-margin"
              type="cta-1"
              @click.native="showPaymentMethodModal = true;"
              data-ec="billing_add_credits_modal"
              data-et="add_method_button">
            <PlusIcon />
            <span>{{ $t('companySettings.billing.paymentMethods.addPaymentMethod') }}</span>
          </VButton>
          <VButton
            type="cta-1"
            class="float-right add-credits-modal__button-margin"
            subtype="submit"
            href="#"
            data-ec="billing_add_credits_modal"
            data-et="next_button"
            :disabled="!paymentMethods.length || paymentMethodPending">
            <ArrowRightIcon />
            <span>{{ $t('functional.next') }}</span>
          </VButton>
        </div>
      </VForm>
    </div>
    <AddPaymentMethodModal :show="showPaymentMethodModal"  @close="showPaymentMethodModal = false;" />
    <AddCreditsInvoicePreviewModal :show="showCreditsInvoiceModal" @close="showCreditsInvoiceModal = false;" :quantity="parseInt(quantity)" />
  </ElDialog>
</template>

<script>
import { mapGetters } from 'vuex';
import VButton from '@/components/deprecated/atoms/Button.vue';
import VCheckbox from '@/components/deprecated/atoms/Checkbox.vue';
import VMessage from '@/components/deprecated/atoms/Message.vue';
import VForm from '@/components/deprecated/organisms/Form.vue';
import VGrid from '@/components/deprecated/organisms/Grid.vue';
import AddPaymentMethodModal from '@/views/modals/payment/AddPaymentMethodModal.vue';
import AddCreditsInvoicePreviewModal from '@/views/modals/payment/PaygInvoicePreviewModal.vue';
import { ArrowRightIcon, ExclamationTriangleIcon, InfoCircleIcon, PlusIcon } from '@/components/icons/fontIcons';

export default {
  name: 'AddCreditsModal',
  inject: {
    $validator: '$validator',
  },
  components: {
    VButton,
    VCheckbox,
    VMessage,
    VForm,
    VGrid,
    AddPaymentMethodModal,
    AddCreditsInvoicePreviewModal,
    ArrowRightIcon,
    PlusIcon,
    InfoCircleIcon,
    ExclamationTriangleIcon,
  },
  props: {
    show: Boolean,
  },
  data() {
    return {
      showPaymentMethodModal: false,
      showCreditsInvoiceModal: false,
      loading: false,
      quantity: '10',
    };
  },
  mounted() {
    if (this.company && this.company.new_billing_enabled) {
      this.$store.dispatch('paygPlans/GET');
    }
  },
  computed: {
    ...mapGetters({
      company: 'company/company',
      paymentMethods: 'paymentMethods/results',
      paygPlans: 'paygPlans/results',
    }),
    paymentMethodPending() {
      if (this.paymentMethods && this.paymentMethods.length) {
        const defaultMethod = this.paymentMethods.find(method => method.is_default === true);
        if (defaultMethod.status === 'pending') return true;
      }

      return false;
    },
  },
  methods: {
    onBeforeCloseModal() {
      const scope = this.$refs.form.$el.getAttribute('data-vv-scope');
      this.errors.clear(scope);
      return true;
    },
    closeModal() {
      this.loading = false;
      this.$emit('close');
    },
    openInvoicePreview() {
      if (this.paymentMethods.length) {
        this.closeModal();
        this.showCreditsInvoiceModal = true;
      }
    },
  },
};
</script>

<style scoped>
.o-form__buttons {
  margin-top: 0;
}

.add-credits-modal__button-margin {
  margin-top: var(--spacing-base);
}

.purchase-credits-modal__grid {
  grid-row-gap: 0;
}

.purchase-credits-modal__grid {
  grid-auto-flow: column;
  grid-template-rows: repeat(4, 1fr);
}
</style>
